import React, { Component } from 'react';
import Modal from '../Modal/Modal';
import { toggleModal } from '../Modal/modalActions';
import { getDataByUniqueModalName } from '../Modal/modalViewState';
import { transactionShape } from '../../utils/propTypes';
import { connect } from 'react-redux';
import { captureTransaction } from './captureActions';
import PropTypes from 'prop-types';
import {
    EmvioValidatedButton,
    EmvioValidatedForm,
    EmvioValidatedInput
} from '@nexio/emvio-form-components';
import {
    currencyMapper,
    doesPropExistAndHasItChanged,
    prettifyMoney,
    gatewayType,
    asyncGatewayList
} from '@nexio/emvio-util-app';
import {
    getIsCaptureLoadingById,
    getIsCaptureSuccessfulById,
    getCaptureErrorMessageById
} from './captureEntity';
import {
    arrayOfStringsToStringWithSeparator,
    getGoodAmountNumber,
    prettifyDate
} from '../../utils/string';
import { toast } from 'react-toastify';
import _ from 'lodash';
import './Capture.scss';

export class Capture extends Component {
    static propTypes = {
        error: PropTypes.string,
        isLoading: PropTypes.bool,
        isSuccessful: PropTypes.bool,
        onCaptureTransaction: PropTypes.func,
        onToggleModal: PropTypes.func,
        transaction: transactionShape
    };

    static defaultProps = {
        transaction: {}
    };

    constructor(props) {
        super(props);

        this.handleCapture = this.handleCapture.bind(this);
        this.onUpdateAmount = this.onUpdateAmount.bind(this);
        this.resetCaptureAmount = this.resetCaptureAmount.bind(this);

        this.state = {
            amount: '0'
        };
    }

    componentDidUpdate(prevProps) {
        const gatewayType = _.get(this.props, 'transaction.gateway.gatewayType');
        const asyncGateway = _.find(asyncGatewayList, { gatewayType });
        const captureIsAsync = _.get(asyncGateway, 'captureIsAsync') || false;
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSuccessful') && this.props.isSuccessful === true) {
            const toastMessage = captureIsAsync ? 'Capture request received' : 'Capture successful';
            this.props.onToggleModal(this.props.transaction);
            toast(toastMessage, { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'transaction')) {
            const amount = _.get(this.props, 'transaction.foreignProcessingCurrency.amount') || _.get(this.props, 'transaction.amount');
            const currencyId = _.get(this.props, 'transaction.foreignProcessingCurrency.currencyId') || _.get(this.props, 'transaction.currencyId');
            const decimalPlaces = _.get(currencyMapper, `${currencyId}.decimalPlaces`);
            this.setState({ amount: getGoodAmountNumber(amount, decimalPlaces) });
        }
    }

    renderAttribute(title = '', value) {
        if (value) {
            return (
                <div className="attribute">
                    <div className="title">{title.toUpperCase()}</div>
                    <div className="value">{value}</div>
                </div>
            );
        }

        return null;
    }

    handleCapture(e) {
        e.preventDefault();

        this.props.onCaptureTransaction(this.props.transaction, this.state.amount);
    }

    onUpdateAmount(e) {
        const amount = e.target.value;

        this.setState({ amount });
    }

    resetCaptureAmount() {
        if (this.props.error) {
            this.setState({ amount: this.props.transaction.amount });
        }
    }

    render() {
        const { transaction } = this.props;

        const customerFirstName = _.get(transaction, 'customer.firstName', '');
        const customerLastName = _.get(transaction, 'customer.lastName', '');
        const customerName = arrayOfStringsToStringWithSeparator([customerFirstName, customerLastName]);

        const amount = _.get(transaction, 'foreignProcessingCurrency.amount') || _.get(transaction, 'amount');
        const currencyId = _.get(transaction, 'foreignProcessingCurrency.currencyId') || _.get(transaction, 'currencyId', '840');
        const currency = currencyMapper[currencyId].code;

        let disallowPartialCaptures = false;
        if ([gatewayType.reach].includes(_.get(transaction, 'gateway.gatewayType'))) {
            disallowPartialCaptures = true;
        }
        const captureError = this.props.error;

        return (
            <Modal uniqueModalName="capture" title="Capture Transaction" resetAmountOnClose={this.resetCaptureAmount}
                captureError={captureError}>
                <EmvioValidatedForm className="emvio-capture-popup" onSubmit={this.handleCapture}>
                    {this.renderAttribute('Customer', customerName)}
                    {this.renderAttribute('Date', prettifyDate(transaction.transactionDate, { returnDateOnly: true }))}
                    {this.renderAttribute('Reference Number', _.get(transaction, 'gateway.refNumber'))}
                    {this.renderAttribute('Amount', `${prettifyMoney(amount, currency)} ${_.toUpper(currency)}`)}
                    {disallowPartialCaptures ? null : <div className="input">
                        <EmvioValidatedInput
                            autoCapitalize="off"
                            autoCorrect="off"
                            autoFocus
                            invert
                            labelText="CAPTURE AMOUNT"
                            largeMode
                            name="amount"
                            onChange={this.onUpdateAmount}
                            placeholder="0.00"
                            shouldEnforceNumber
                            type="text"
                            validations={['required']}
                            value={`${this.state.amount}`}
                        />
                    </div>}
                    <EmvioValidatedButton invertColors isLoading={this.props.isLoading}>
                        Capture {`${prettifyMoney(this.state.amount, currency)} ${_.toUpper(currency)}`}
                    </EmvioValidatedButton>
                </EmvioValidatedForm>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    const transaction = getDataByUniqueModalName(state, 'capture');
    const id = _.get(transaction, 'id');

    return {
        error: getCaptureErrorMessageById(state, id),
        isLoading: getIsCaptureLoadingById(state, id),
        isSuccessful: getIsCaptureSuccessfulById(state, id),
        transaction
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCaptureTransaction: (transaction, amountToCapture) => dispatch(captureTransaction(transaction, amountToCapture)),
        onToggleModal: (transaction) => dispatch(toggleModal('capture', transaction))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Capture);
